import { Col, Row, Modal, Form, Switch, Select, Button, message } from "antd";
import { useTranslation } from "react-i18next";
import { Dispatch, useState } from "react";
import { UseMutateAsyncFunction, useMutation, useQuery } from "react-query";
import Title from "../../UI/Title/Title";
import AddEditModal from "../../UI/ModalComponent/AddEditModal/addeditcomponent";
import { ItemModifierType } from "./ItemModifierType";
import {
  createItemModifier,
  editItemModifier,
} from "../../../api/itemModifiers";
import { getItemsBy } from "../../../api/itemapi";
import { AxiosResponse } from "axios";
import { InputNumber } from "../../UI/InputNumberComponent/inputnumber";
import TextArea from "../../UI/InputNumberComponent/TextArea";

type propsType = {
  itemid?: string;
  formatedItemModifier: any;
  loadingItemModifier: any;
  id?: string | number;
  openItemModifier: boolean;
  itemModifier?: ItemModifierType | undefined;
  setOpenItemModifier: React.Dispatch<React.SetStateAction<boolean>>;
  filter: any;
  search: any;
  setPaginatedModifiersComponent: Dispatch<any>;
  ItemID: string | undefined;
  ItemModifierMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      itemid: string | number | undefined;
      q: string;
      isActive?: boolean | undefined;
    },
    unknown
  >;
};
export const AddEditItemModifier = ({
  openItemModifier,
  itemModifier,
  itemid,
  setOpenItemModifier,
  id,
  loadingItemModifier,
  formatedItemModifier,
  search,
  filter,
  ItemModifierMutation,
  setPaginatedModifiersComponent,
  ItemID,
}: propsType) => {
  const [t] = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [, setError] = useState("");
  const [selectedModifier, setSelectedModifier] = useState<any>(null);
  const [price, setPrice] = useState(false);
  const handleNameChange = (value: any) => {
    setPrice(value);
  };
  const isEdit = () => {
    return !!id && id !== undefined && id !== "";
  };

  const [isActive, setIsActive] = useState<boolean>(
    itemModifier ? itemModifier?.isActive : true
  );

  const [itemName, setItemName] = useState("");
  useQuery("item", () => getItemsBy(itemid), {
    onSuccess: (itemName) => {
      setItemName(itemName);
    },
  });
  const onError = (
    error: any,
    variables: ItemModifierType,
    context: unknown
  ) => {
    let errorMessage = "An error occurred";
    if (error.response && error.response.data && error.response.data.errors) {
      const errorData = error.response.data.errors[0];
      if (errorData && errorData.msg) {
        errorMessage = `${errorData.param} ${errorData.msg}`;
      }
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      errorMessage = error.response.data.message;
    } else {
      errorMessage = error.message;
    }
    if (setError) {
      setError(errorMessage);
    }
    message.error({
      content: errorMessage,
      duration: 10,
      onClick: () => {
        message.destroy();
      },
    });
  };

  const { mutateAsync: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createItemModifier" : "editItemModifier",
    !isEdit()
      ? (modifier: ItemModifierType) => createItemModifier(modifier)
      : (modifier: ItemModifierType) => editItemModifier(id, modifier),
    {
      onSuccess: (res) => {
        setOpen(false);
        if (open) {
          setOpenItemModifier(false);
        }
        message.success("Complete successfully");
        ItemModifierMutation({
          itemid: ItemID,
          q: search,
          isActive: filter,
        }).then((res: any) => {
          setPaginatedModifiersComponent(res.data);
        });
      },
      onError,
    }
  );

  const handleFinish = async (isClose: boolean) => {
    const newItemModifier = form.getFieldsValue();

    for (const key in newItemModifier) {
      if (newItemModifier[key] === undefined) {
        if (key === "isActive") {
          newItemModifier[key] = true;
        } else {
          newItemModifier[key] = null;
        }
      } else if (
        typeof newItemModifier[key] === "string" &&
        newItemModifier[key].trim() === ""
      ) {
        newItemModifier[key] = null;
      }
    }
    newItemModifier["itemId"] = itemid;
    mutateCreateUpdate(newItemModifier).then(() => {
      isClose && setOpenItemModifier(false);
      form.resetFields();
    });
  };
  const handleCancel = () => {
    form.resetFields();
    setSelectedModifier(null);
    setPrice(false);
  };
  return (
    <>
      <Modal
        data-testid="modal"
        closable={false}
        maskClosable={false}
        centered
        width={450}
        onCancel={() => setOpenItemModifier(false)}
        open={openItemModifier}
        cancelText={t("cancel")}
        footer={null}
      >
        <Col offset={1}>
          {" "}
          <Title
            title={isEdit() ? `${t("edit-modifier")}` : `${t("add-modifier")}`}
          />
        </Col>
        {isEdit() ? (
          <Col offset={1} className="modaltitleEdit">
            {t("edit-modifier-to")} {""} {itemName}
          </Col>
        ) : (
          <Col offset={1} className="modaltitleEdit">
            {t("add-modifier-to")} {""}
            {itemName}
          </Col>
        )}
        <Form
          className="no-hover-label"
          data-testid="form"
          layout="vertical"
          onFinish={() => handleFinish(false)}
          form={form}
          id="ModifierForm"
          initialValues={{
            modifierId: itemModifier?.modifier?.id,
            price: itemModifier?.price,
            notes: itemModifier?.notes,
            isActive: isEdit() ? itemModifier?.isActive : true,
          }}
        >
          <Row style={{ marginTop: "20px" }}>
            <Col span={19} offset={1}>
              <Form.Item
                label={`${t("modifier")}`}
                name="modifierId"
                rules={[
                  {
                    required: true,
                    message: "modifier is required",
                  },
                ]}
              >
                <Select
                  loading={loadingItemModifier}
                  options={formatedItemModifier}
                  placeholder={`${t("select-modifier")}`}
                  showSearch={true}
                  optionFilterProp="label"
                  onChange={(value: any) => setSelectedModifier(value)}
                />
              </Form.Item>
              <Form.Item
                name="price"
                label={`${t("price")}`}
                rules={[
                  {
                    required: true,
                    message: "price is required",
                  },
                ]}
              >
                <InputNumber onChange={handleNameChange} maxLength={11} />
              </Form.Item>

              <Form.Item name="isActive" label={`${t("status")}`}>
                <Switch
                  checkedChildren={`${t("active")}`}
                  unCheckedChildren={`${t("inactive")}`}
                  checked={isActive}
                  disabled={isEdit() ? false : true}
                  onChange={(num: boolean) => {
                    setIsActive(num);
                  }}
                />
              </Form.Item>

              <Form.Item name="notes" label={`${t("notes")}`}>
                <TextArea maxLength={500} />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col offset={isEdit() ? 11 : 1}>
              <Button
                data-testid="cancel"
                size="large"
                style={{
                  color: "#1677FF",
                  border: "1px solid #1677FF",
                  width: "100px",
                }}
                onClick={() => {
                  setOpenItemModifier(false);
                  handleCancel();
                }}
              >
                {t("cancel")}
              </Button>
            </Col>
            {isEdit() ? (
              <Col offset={1}>
                <Button
                  htmlType="submit"
                  form="Componentform"
                  style={{
                    width: "100px",
                    background: "#1677FF",
                    color: "#fff",
                    height: "40px",
                    border: "none",
                  }}
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  {t("save")}
                </Button>
              </Col>
            ) : (
              <Col offset={4}>
                <Button
                  data-testid="save"
                  style={{
                    width: "100px",
                    background: "#1677FF",
                    color: "#fff",
                    height: "40px",
                    border: "none",
                  }}
                  loading={isSaving}
                  disabled={!price || !selectedModifier || isSaving}
                  onClick={() => {
                    handleFinish(true);
                  }}
                >
                  {isSaving ? `${t("loading")}` : `${t("Save & Close")}`}
                </Button>
              </Col>
            )}
            {isEdit() ? (
              <></>
            ) : (
              <Col offset={1}>
                <Button
                  data-testid="save"
                  htmlType="submit"
                  form="ModifierForm"
                  style={{
                    width: "100px",
                    background: "#1677FF",
                    color: "#fff",
                    height: "40px",
                    border: "none",
                  }}
                  disabled={!price || !selectedModifier || isSaving}
                >
                  {isSaving ? `${t("loading")}` : `${t("save-&-add")}`}
                </Button>
              </Col>
            )}
          </Row>
        </Form>
      </Modal>
      <AddEditModal
        form="ModifierForm"
        open={open}
        setOpen={setOpen}
        name={<span>{itemModifier?.modifier?.name}</span>}
        title={`${t("modifieries")}`}
        id={id}
        isSaving={isSaving}
      />
    </>
  );
};
